import { Icon } from "../Icon/Icon";
export const TextButton = ({
	size = "Large",
	children,
	type,
	disabled,
	icon,
	loadingIcon,
	onClick,
	loading,
}) => {
	const baseClassName = `inline-flex items-center gap-1`;

	const typeClass = `${
		disabled
			? type === "Primary"
				? "text-color_text_primary_1 cursor-not-allowed"
				: type === "Secondary"
					? "text-color_text_grey_1 cursor-not-allowed"
					: type === "Critical"
						? "text-color_text_grey_1 cursor-not-allowed"
						: type === "White"
							? "text-color_text_grey_3 cursor-not-allowed"
							: "text-gray-500 cursor-not-allowed" //Default
			: type === "Primary"
				? "text-color_text_primary_3 hover:text-color_text_primary_4 active:text-color_text_primary_5"
				: type === "Secondary"
					? "text-color_text_grey_5 hover:text-color_text_grey_4 active:text-color_text_grey_3 "
					: type === "Critical"
						? "text-color_text_negative_3 hover:text-color_text_negative_4 active:text-color_text_negative_5"
						: type === "White"
							? "text-white hover:text-color_text_grey_1 active:text-color_text_grey_2"
							: "text-gray-500 hover:text-gray-400 active:text-gray-500" //default
	}`;
	const buttonSize =
		size === "Large"
			? "ButtonL"
			: size === "Medium"
				? "ButtonM"
				: size === "Small"
					? "ButtonS"
					: "ButtonL";
	return (
		<button
			className={`${baseClassName} ${typeClass}`}
			disabled={disabled || loading}
			onClick={onClick}
		>
			{icon && !loading && (
				<div className="">
					<Icon iconName={icon} size={size} />
				</div>
			)}
			{loading && loadingIcon && (
				<div className="">
					{" "}
					<Icon iconName={loadingIcon} size={size} />
				</div>
			)}
			{!loading && <div className={buttonSize}>{children}</div>}
		</button>
	);
};
